import { t } from "@/i18n-js/instance";
import {
  isOneTimePrice,
  isSubscriptionPrice,
} from "@circle-react/helpers/paywallPriceHelpers";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallPriceScenario } from "@circle-react/types";
import type { Paywall, PaywallPrice } from "@circle-react/types";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Price } from "./Price";
import { defaultFormatPaywallCurrency } from "./constants";
import type { PriceScenariosProps } from "./types";

const scenariosResolver: Record<
  PaywallPriceScenario,
  Array<(props: PriceScenariosProps) => React.ReactNode>
> = {
  value: [Price],
  trial_then_value: [Price.Badge, Price.ValueWithArrow],
  trial_then_upfront_then_value: [
    Price.Badge,
    Price.IntroFeeWithArrow,
    Price.ValueWithArrow,
  ],
  upfront_then_value: [Price.IntroFee, Price.ValueWithArrow],
  upfront_then_trial_then_value: [
    Price.IntroFee,
    Price.BadgeWithArrow,
    Price.ValueWithArrow,
  ],
};

const getSubtitle = (price: PaywallPrice, paywall: Paywall) => {
  if (isSubscriptionPrice(price) || isOneTimePrice(price)) {
    return price.title;
  }

  return t(
    [
      "paywall_checkout.price_value.title",
      price.price_type,
      price.interval_type,
    ],
    {
      total_amount: formatPaywallCurrencyAmount(
        paywall.currency,
        price.amount,
        defaultFormatPaywallCurrency,
      ),
    },
  );
};

export const PriceDescription = ({ price, paywall }: PriceScenariosProps) => {
  const subtitle = getSubtitle(price, paywall);
  const components = scenariosResolver[price.scenario];

  return (
    <div className="flex flex-col gap-y-1">
      <div key={price.id} className="leading-6">
        {components.map(component => component({ price, paywall }))}
      </div>
      <Typography.LabelXs color="text-default">{subtitle}</Typography.LabelXs>
    </div>
  );
};
